import axios from 'axios'
import config from '@/lib/config'
import utils from '@/lib/utils'
import api from '@/lib/api'
import store from '@/store'
import { matchFlags } from './blood'
import _ from 'lodash'

async function requestPrintService (printOptions, settings) {
  try {
    const response = await axios({
      method: 'post',
      url: settings.url,
      data: printOptions,
      timeout: settings.timeout
    })
    if (response.status >= 200 && response.status < 300) {
      const result = response.data
      if (typeof result.success !== 'boolean') {
        result.success = result.code >= 200 && result.code < 300
      }
      if (!result.success) {
        console.warn(`请求标签打印服务接口异常(状态码:${response.status})`, result, response)
      }
      return utils.perfectApiResult(result)
    } else {
      const message = `请求标签打印服务接口失败(状态码:${response.status})`
      console.warn(message, response)
      return utils.perfectApiResult({
        success: false,
        code: response.status,
        message: message
      })
    }
  } catch (error) {
    const message = '请求标签打印服务接口时发生网络错误'
    const errorResult = utils.perfectApiResult({
      success: false,
      error: true,
      code: 0,
      message: message
    })
    console.error(message, error, errorResult)
    return errorResult
  }
}

function matchTemplates (flags) {
  const templates = store.getters['bis/word/getWordsListByType']('label_template')
  console.log('allTemplates', templates)
  const matchedTemplates = templates?.filter(item => matchFlags(item.data, flags, true))
  return matchedTemplates
}

function selectTemplate (templates, source) {
  const filteredTemplates = source ? templates?.filter(item => !item.data.filter || item.data.filter(source)) : templates
  filteredTemplates && filteredTemplates.sort((item1, item2) => (item1.sort ?? 0) - (item2.sort ?? 0))
  return (source && filteredTemplates?.find(item => item.data.filter)) ||
    filteredTemplates?.find(item => item.data.default) ||
    filteredTemplates?.at(0)
}

function prefectPrintSource (printSource) {
  if (printSource && typeof printSource === 'object') {
    for (const key in printSource) {
      const value = printSource[key]
      // 将 null / undefined 换成空字符串
      if (_.isNil(value)) {
        printSource[key] = ''
      }
    }
  }
  return printSource
}

function prefectPrintSourceList (printSourceList) {
  if (printSourceList?.length) {
    for (const printSource of printSourceList) {
      prefectPrintSource(printSource)
    }
  }
  return printSourceList
}

function prefectPrintOptions ({
  templateFile,
  printSourceList,
  printerName,
  copiesNum
}, flags, settings) {
  if (templateFile) {
    return [{
      templateFile,
      printSourceList: prefectPrintSourceList(printSourceList),
      printerName,
      copiesNum
    }]
  } else {
    const matchedTemplates = matchTemplates(flags)
    console.log('matchedTemplates:', matchedTemplates, flags)
    const optionsMap = new Map()
    for (const source of printSourceList) {
      const selectedTemplate = selectTemplate(matchedTemplates, source)
      const selectedTemplateFile = selectedTemplate?.data.path
      let options = optionsMap.get(selectedTemplateFile)
      if (options) {
        options.printSourceList.push(prefectPrintSource(source))
      } else {
        options = {
          templateFile: selectedTemplateFile,
          printSourceList: [prefectPrintSource(source)],
          printerName,
          copiesNum
        }
        optionsMap.set(selectedTemplateFile, options)
      }
    }
    return optionsMap.values()
  }
}

export function selectDefaultTemplate (flags) {
  const matchedTemplates = matchTemplates(flags)
  return selectTemplate(matchedTemplates)
}

async function logPrint ({ logOptions, printResult, flags, settings, printOptions }) {
  logOptions = Object.assign(({
    terminalId: store.state?.bis?.authorize?.terminal?.id,
    printUrl: settings.url,
    result: JSON.stringify(printResult),
    content: JSON.stringify(printOptions)
  }), logOptions)
  const logResult = await api.bis.post('/log/labelPrint/', logOptions)
  logResult.notifyIfFail(logResult.success ? null : `记录打印日志失败: ${logResult.message}`)
  return logResult
}

async function printLabelList (category, printOptions, logOptions) {
  await store.dispatch('bis/word/loadWords')
  const settings = config.bis.labelPrinters[category]
  const flags = {
    [category]: true
  }
  const printOptionsList = prefectPrintOptions(printOptions, flags, settings)
  let printResult
  for (const printOptions of printOptionsList) {
    printResult = await requestPrintService(printOptions, settings)
    await logPrint({ logOptions, printResult, flags, settings, printOptions })
  }
  return printResult
}

function printLabel (category, printOptions, logOptions) {
  const printListOptions = {
    ...printOptions,
    printSourceList: [printOptions.printSource]
  }
  delete printListOptions.printSource
  return printLabelList(category, printListOptions, logOptions)
}

export function printDonLabelList (printOptions, logOptions) {
  return printLabelList('don', printOptions, logOptions)
}

export function printDonLabel (printOptions, logOptions) {
  return printLabel('don', printOptions, logOptions)
}

export function printProductLabelList (printOptions, logOptions) {
  return printLabelList('product', printOptions, logOptions)
}

export function printProductLabel (printOptions, logOptions) {
  return printLabel('product', printOptions, logOptions)
}

export function printPatientSpecimenLabelList (printOptions, logOptions) {
  return printLabelList('patientSpecimen', printOptions, logOptions)
}

export function printRPRLabelList (printOptions, logOptions) {
  return printLabelList('prpProcess', printOptions, logOptions)
}

export function printPatientSpecimenLabel (printOptions, logOptions) {
  return printLabel('patientSpecimen', printOptions, logOptions)
}

export function printReactionCardLabelList (printOptions, logOptions) {
  return printLabelList('reactionCard', printOptions, logOptions)
}

export function printReactionCardLabel (printOptions, logOptions) {
  return printLabel('reactionCard', printOptions, logOptions)
}

export function printReactionCardPlateletLabelList (printOptions, logOptions) {
  return printLabelList('reactionCardPlatelet', printOptions, logOptions)
}

export function printReactionCardPlateletLabel (printOptions, logOptions) {
  return printLabel('reactionCardPlatelet', printOptions, logOptions)
}
